import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BusinessListings from './components/BusinessListings';
import AddBusinessForm from './components/AddBusinessForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import * as businessService from './services/businessService';

const initialCategories = [
  {
    id: 1,
    name: 'Grocery Stores',
    icon: '🛒',
    description: 'Supermarkets & Retail',
    color: '#FF6B9D',
    businesses: [
      {
        id: 1,
        name: 'Dandekar And Company',
        type: 'Supermarkets, Departmental Stores',
        address: 'Girish Marg Janaki Apartment, Vishrambag, Sangli, Maharashtra 416406',
        phone: '0233 233 2070',
        hours: '8:30 am - 9:00 pm',
        mapUrl: 'https://maps.google.com/?q=Dandekar+Company+Sangli'
      },
      {
        id: 2,
        name: 'Sarthak Shopee',
        type: 'Supermarkets, Departmental Stores',
        address: 'Somwar Peth, Madhavnagar, Sangli Miraj Kupwad, Maharashtra 416406',
        phone: '+91 9174264409',
        hours: '7:00 am - 10:00 pm',
        mapUrl: 'https://maps.google.com/?q=Sarthak+Shopee+Sangli'
      }
    ]
  },
  {
    id: 2,
    name: 'Healthcare',
    icon: '⚕️',
    description: 'Doctors, Chemists & Clinics',
    color: '#4ECDC4',
    businesses: [
      {
        id: 3,
        name: 'Sangli Health Centre',
        type: 'Multi-Specialty Hospital',
        address: 'Main Road, Sangli, Maharashtra',
        phone: '0233 233 1234',
        hours: '24/7',
        mapUrl: 'https://maps.google.com/?q=Sangli+Health+Centre'
      },
      {
        id: 4,
        name: 'Vaidya Clinic',
        type: 'Ayurvedic Clinic',
        address: 'Market Street, Sangli, Maharashtra',
        phone: '0233 233 5000',
        hours: '9:00 am - 6:00 pm',
        mapUrl: 'https://maps.google.com/?q=Vaidya+Clinic+Sangli'
      }
    ]
  },
  {
    id: 3,
    name: 'Restaurants',
    icon: '🍽️',
    description: 'Dining & Beverages',
    color: '#F38181',
    businesses: [
      {
        id: 5,
        name: 'Spice Corner',
        type: 'Veg/Non-Veg, Multi Cuisines',
        address: 'Market Street, Sangli, Maharashtra',
        phone: '0233 233 5678',
        hours: '11:00 am - 11:00 pm',
        mapUrl: 'https://maps.google.com/?q=Spice+Corner+Sangli'
      },
      {
        id: 6,
        name: 'Maharaja Restaurant',
        type: 'North Indian Cuisine',
        address: 'Station Road, Sangli, Maharashtra',
        phone: '0233 233 6789',
        hours: '10:00 am - 10:30 pm',
        mapUrl: 'https://maps.google.com/?q=Maharaja+Restaurant+Sangli'
      }
    ]
  },
  {
    id: 4,
    name: 'Photography',
    icon: '📷',
    description: 'Professional Photography',
    color: '#AA96DA',
    businesses: [
      {
        id: 7,
        name: 'Studio Art Photography',
        type: 'Wedding & Event Photography',
        address: 'Commercial Area, Sangli, Maharashtra',
        phone: '0233 233 7890',
        hours: '10:00 am - 8:00 pm',
        mapUrl: 'https://maps.google.com/?q=Studio+Art+Sangli'
      }
    ]
  },
  {
    id: 5,
    name: 'Hotels',
    icon: '🏨',
    description: 'Lodging & Hospitality',
    color: '#FCBAD3',
    businesses: [
      {
        id: 8,
        name: 'Grand Hotel Sangli',
        type: 'Premium Hotel',
        address: 'Central Plaza, Sangli, Maharashtra',
        phone: '0233 233 8901',
        hours: '24/7',
        mapUrl: 'https://maps.google.com/?q=Grand+Hotel+Sangli'
      }
    ]
  },
  {
    id: 6,
    name: 'Legal Services',
    icon: '⚖️',
    description: 'Consultants & Advocates',
    color: '#A8E6CF',
    businesses: [
      {
        id: 9,
        name: 'Sharma & Associates',
        type: 'Legal Consultants',
        address: 'Law Court Complex, Sangli, Maharashtra',
        phone: '0233 233 9012',
        hours: '9:00 am - 5:30 pm',
        mapUrl: 'https://maps.google.com/?q=Sharma+Associates+Sangli'
      }
    ]
  },
  {
    id: 7,
    name: 'Food & Juice',
    icon: '🥤',
    description: 'Catering Services',
    color: '#FFD3B6',
    businesses: [
      {
        id: 10,
        name: 'Fresh Juice Centre',
        type: 'Juice & Beverage',
        address: 'Garden Area, Sangli, Maharashtra',
        phone: '0233 233 0123',
        hours: '7:00 am - 9:00 pm',
        mapUrl: 'https://maps.google.com/?q=Fresh+Juice+Centre+Sangli'
      }
    ]
  },
  {
    id: 8,
    name: 'Automobiles',
    icon: '🚗',
    description: 'Cars & Vehicles',
    color: '#FF9AA2',
    businesses: [
      {
        id: 11,
        name: 'Premium Motors',
        type: 'Car Showroom',
        address: 'Highway Road, Sangli, Maharashtra',
        phone: '0233 233 1234',
        hours: '10:00 am - 7:00 pm',
        mapUrl: 'https://maps.google.com/?q=Premium+Motors+Sangli'
      }
    ]
  }
];

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddBusinessForm, setShowAddBusinessForm] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);

  // Initialize categories from localStorage or use defaults
  useEffect(() => {
    const savedCategories = localStorage.getItem('sangliBusinesses');
    if (savedCategories) {
      try {
        setCategories(JSON.parse(savedCategories));
      } catch (error) {
        console.error('Error loading categories:', error);
        setCategories(initialCategories);
      }
    } else {
      setCategories(initialCategories);
    }
  }, []);

  // Save categories to localStorage
  const saveCategories = (updatedCategories) => {
    setCategories(updatedCategories);
    localStorage.setItem('sangliBusinesses', JSON.stringify(updatedCategories));
  };

  // Handle adding new business
  const handleAddBusiness = async (businessData) => {
    try {
      // Add business via API
      const newBusiness = await businessService.addBusiness(businessData);
      
      // Update local state
      const updatedCategories = categories.map(category => {
        if (category.name === businessData.category) {
          return {
            ...category,
            businesses: [...category.businesses, newBusiness]
          };
        }
        return category;
      });

      saveCategories(updatedCategories);
      setShowAddBusinessForm(false);
      
      // Show success message
      alert('✅ Business added successfully! It will be reviewed and appear in the directory shortly.');
    } catch (error) {
      const errorMessage = businessService.handleApiError(error);
      alert(`❌ Error adding business: ${errorMessage}`);
      console.error('Error adding business:', error);
    }
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setCurrentPage('listings');
    window.scrollTo(0, 0);
  };

  const handleBackHome = () => {
    setCurrentPage('home');
    setSelectedCategory(null);
    setSearchQuery('');
    window.scrollTo(0, 0);
  };

  // Admin Functions
  const handleUpdateBusiness = (updatedBusiness) => {
    const updatedCategories = categories.map(category => {
      if (category.name === updatedBusiness.categoryName) {
        return {
          ...category,
          businesses: category.businesses.map(biz =>
            biz.id === updatedBusiness.id ? updatedBusiness : biz
          )
        };
      }
      return category;
    });

    saveCategories(updatedCategories);
    alert('✅ Business updated successfully!');
  };

  const handleDeleteBusiness = (businessId, categoryName) => {
    const updatedCategories = categories.map(category => {
      if (category.name === categoryName) {
        return {
          ...category,
          businesses: category.businesses.filter(biz => biz.id !== businessId)
        };
      }
      return category;
    });

    saveCategories(updatedCategories);
    alert('✅ Business deleted successfully!');
  };

  // If admin is logged in, show admin dashboard
  if (isAdminLoggedIn) {
    return (
      <AdminDashboard
        categories={categories}
        onUpdateBusiness={handleUpdateBusiness}
        onDeleteBusiness={handleDeleteBusiness}
        onLogout={() => {
          setIsAdminLoggedIn(false);
          setCurrentPage('home');
        }}
      />
    );
  }

  // If admin login is shown, display login form
  if (showAdminLogin) {
    return <AdminLogin onLogin={() => setIsAdminLoggedIn(true)} />;
  }

  const filteredCategories = (categories.length > 0 ? categories : initialCategories).filter(cat =>
    cat.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    cat.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="App">
      <Header onAdminClick={() => setShowAdminLogin(true)} />
      
      {currentPage === 'home' ? (
        <>
          <HeroSection 
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />
          <CategoryGrid 
            categories={filteredCategories}
            onCategoryClick={handleCategoryClick}
          />
          <section className="about-section">
            <div className="about-container">
              <h3>About Sangli</h3>
              <p>
                Sangli is a district in Maharashtra, created in 1949. It's a vibrant commercial hub 
                with diverse businesses ranging from retail to services. Find everything you need 
                locally with just a few clicks. Our mission is to connect you with the best local 
                businesses and services in Sangli.
              </p>
            </div>
          </section>
        </>
      ) : (
        <BusinessListings 
          category={selectedCategory}
          onBackClick={handleBackHome}
        />
      )}
      
      {/* Add Business Button */}
      <button 
        className="floating-add-button"
        onClick={() => setShowAddBusinessForm(true)}
        title="Add your business"
      >
        ➕
      </button>

      {/* Add Business Form Modal */}
      {showAddBusinessForm && (
        <AddBusinessForm
          onSubmit={handleAddBusiness}
          onCancel={() => setShowAddBusinessForm(false)}
          categories={filteredCategories}
        />
      )}
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Amachi Sangli</h4>
            <p>One Stop Solution For Your Business Search</p>
          </div>
          <div className="footer-section">
            <h5>Quick Links</h5>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#business">Business</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h5>Contact</h5>
            <p>📍 India</p>
            <p>📞 +91 9019551597</p>
            <p>📧 contact@amachisangli.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Sangli Business Directory. All rights reserved.</p>
          <p style={{ marginTop: '0.5rem', fontSize: '12px' }}>
            💡 <button 
              onClick={() => setShowAddBusinessForm(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#ff6b35',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              Add Your Business Today
            </button>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
